import { SortType } from "../SortType";

export interface InvoiceFilters {
  page_no: number;
  search_text?: string;
  limit: number;
  sort_by: string;
  sort_type: SortType;
}

export interface InvoiceSelectedFilters {
  page_no: number;
  search_text?: string;
  limit: number;
  sort_by: string;
  sort_type: SortType;
}

export interface InvoiceAPIFilters {
  page_no: number;
  search_text?: string;
  limit: number;
  sort_by: string;
  sort_type: SortType;
}

export function parseQueryParamsForInvoiceFilters(
  params: InvoiceFilters | null,
  query_params: URLSearchParams
): InvoiceFilters {
  return {
    page_no: params?.page_no ?? 1,
    search_text: params?.search_text ?? "",
    limit: params?.limit ?? 30,
    sort_by: params?.sort_by ?? "created_date",
    sort_type: params?.sort_type ?? SortType.DESC,
  };
}
